import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Options } from "@angular-slider/ngx-slider";
import * as _ from "underscore";
import { RangeValueAccessor } from "@angular/forms";

@Component({
  selector: "app-search-modal",
  templateUrl: "./search-modal.component.html",
  styleUrls: ["./search-modal.component.css"],
})
export class SearchModalComponent implements OnInit {
  searchBy: string;
  @Input() show: boolean;
  @Input() deleteModal: any;
  @Input() id: any;
  @Input() title: string;
  @Input() employeeDetails = [];
  @Input() showModel: boolean;
  @Input() filterList = [];

  _: any = _;
  @Output() btnName: EventEmitter<any> = new EventEmitter();

  currIndex: any = 0;
  minValue: number = 10;
  maxValue: number = 100;
  options: Options = {
    floor: 0,
    ceil: 100,
  };

  constructor() {}

  ngOnInit(): void {}

  select() {
    console.log("-----FILTER APPLIED-----", this.filterList);
    this.btnName.emit({ data: this.filterList, isClear: false });
  }

  clearSelection() {
    _.each(this.filterList, function (f) {
      if (f.type === "text") {
        _.each(f.subItems, function (item) {
          item.isSelected = false;
        });
      } else {
        f.minValue = f.options['floor'];
        f.maxValue = f.options['ceil'];

        // let rangeValue = [];
        // _.each(f.subItems, function (item) {
        //   if (isFinite(item)) {
        //     rangeValue.push(item);
        //   }
        // });
        // f.minValue = Math.max(...rangeValue);
        // f.maxValue = Math.min(...rangeValue);
      }
    });

    this.btnName.emit({ data: this.filterList, isClear: true });
    console.log("-----CLEAR DONE----", this.filterList);
  }
}
